import { Component, OnInit } from '@angular/core';
import { LayoutModule } from '../layout/layout.module';
import { TlnInfoComponent } from '../tln-info/tln-info.component';
import { WildflowerInfoComponent } from '../wildflower-info/wildflower-info.component';
import { Meta } from '@angular/platform-browser';

@Component({
  standalone: true,
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  imports: [
    TlnInfoComponent,
    WildflowerInfoComponent
  ]
})

export class HomeComponent implements OnInit {
  constructor(private meta: Meta) { }
  ngOnInit () {
    const canonicalTag = this.meta.getTag('rel="canonical"');
   const newCanonicalUrl = "https://www.daylilyventura.com";
    if (canonicalTag) {
      this.meta.updateTag({ rel: 'canonical', href: newCanonicalUrl });
    } else {
      this.meta.addTag({ rel: 'canonical', href: newCanonicalUrl });
    }
  }
}
